// extracted by mini-css-extract-plugin
export default {"h1":"dirigent_h1__mGzQE","main":"dirigent_main__1pDv9"};